/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_confirm_password_simple_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm your password`)
};

const zh_hans1_settings_confirm_password_simple_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认您的密码`)
};

const zh_hant1_settings_confirm_password_simple_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確認您的密碼`)
};

const fr_settings_confirm_password_simple_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmez votre mot de passe`)
};

const de_settings_confirm_password_simple_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort bestätigen`)
};

const ja_settings_confirm_password_simple_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワードを確認`)
};

const ko_settings_confirm_password_simple_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비밀번호를 확인하세요`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_confirm_password_simple_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_confirm_password_simple_placeholder(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_confirm_password_simple_placeholder", locale)
	if (locale === "en") return en_settings_confirm_password_simple_placeholder(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_confirm_password_simple_placeholder(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_confirm_password_simple_placeholder(inputs)
	if (locale === "fr") return fr_settings_confirm_password_simple_placeholder(inputs)
	if (locale === "de") return de_settings_confirm_password_simple_placeholder(inputs)
	if (locale === "ja") return ja_settings_confirm_password_simple_placeholder(inputs)
	return ko_settings_confirm_password_simple_placeholder(inputs)
};